import React, { useRef, useState } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { makeStyles } from '@material-ui/core/styles';

import { Card, CardContent, CardActions, CircularProgress, Grid, IconButton, Slider } from "@material-ui/core";
import PlayIcon from '@material-ui/icons/PlayCircleOutline';
import PauseIcon from '@material-ui/icons/PauseCircleOutline';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeUp from '@material-ui/icons/VolumeUp';
import './App.css';

import logo from "./assets/logomqrmusicaok.png";


const useStyles = makeStyles({
  root: {
    position: "absolute",
    bottom: 0,
    right: 0,
    backgroundColor: "#000000dd",
    width: 300,
    height: "auto",
  },
  logo: {
    width: "100%",
    heigth: "auto",
  },
  controls: {
    marginTop: -35,
    flexFlow: "column",
    backgroundColor: "#555"
  },
  controlButton: {
    color: "#fff",
  },
  controlIcons: {
    fontSize: 40,
  },
  loading: {
    color: "#fff",
  },
  slider: {
    paddingLeft: "20px",
    paddingRight: "20px",
    "& .MuiSlider-root": {
      color: "#fff",
    }
  }
});


function App() {
  const playerRef = useRef(null);
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1.0);

  const src = "https://radioserver11.profesionalhosting.com/proxy/vncesufx?mp=/stream";

  const handleClick = async () => {
    setIsLoading(true);
    if (isPlaying) {
      await playerRef.current.audioEl.current.pause();
    } else {
      await playerRef.current.audioEl.current.play();
    }
    setIsPlaying(!isPlaying);
    setIsLoading(false);
  };

  const handleChangeVolume = (event, newValue) => {
    setVolume(parseFloat(newValue / 100));
  };

  return (
    <div className="App">
      <Card className={classes.root}>
        <CardContent>
          <img className={classes.logo} src={logo} alt="mqrMusica" />
        </CardContent>
        <CardActions className={classes.controls}>
          <IconButton className={classes.controlButton} aria-label="player" onClick={handleClick}>
            {
              isLoading &&
              <CircularProgress className={classes.loading} color="inherit" />
            }
            {
              !isPlaying && !isLoading &&
              <PlayIcon className={classes.controlIcons} />
            }
            {
              isPlaying && !isLoading &&
              <PauseIcon className={classes.controlIcons} />
            }
          </IconButton>
          <Grid container>
            <Grid item>
              <VolumeDown />
            </Grid>
            <Grid item xs className={classes.slider}>
              <Slider color="primary" value={parseFloat(volume * 100)} onChange={handleChangeVolume} aria-labelledby="continuous-slider" />
            </Grid>
            <Grid item>
              <VolumeUp />
            </Grid>
          </Grid>
        </CardActions>
      </Card>
      <ReactAudioPlayer
        ref={playerRef}
        className="mqr-player"
        src={src}
        // autoPlay
        controls
        volume={volume}
      />
    </div>
  );
}

export default App;
